import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { BusinessService } from '../../../core/services/business.service';
import { SecurityPrivacyCookiePolicyComponent } from '../../../components/security-privacy-cookie-policy/security-privacy-cookie-policy.component';
import { TermsAndConditionsComponent } from '../../../components/terms-and-conditions/terms-and-conditions.component';
import { MatDialog } from '@angular/material/dialog';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DataProtection } from '../../data/data-protection';
import { DataProtectionQuestion } from '../../data/data-protection-question';
import { AssessmentService } from '../../services/assessment.service';


interface TextSegment {
  text: string;
  link?: string;
}

@Component({
  selector: 'app-data-protection',
  templateUrl: './data-protection.component.html',
  styleUrl: './data-protection.component.scss'
})
export class DataProtectionComponent implements OnInit {


  @Input()model!: InitialAssessmentForm;
  @Output() formReady = new EventEmitter<FormGroup>();
  showMandatoryQuestion = false;
  showOptionalQuestion1 = false;
  showOptionalQuestion2 = false;
  showOptionalQuestion3 = false;
  showDataProcessorNotice = false;
  showStandardDeclaration = false;
  showLegalText = false;

  mandatoryQuestionSegments: TextSegment[] = [];
  optionalQuestion1Segments: TextSegment[] = [];
  optionalQuestion2Segments: TextSegment[] = [];
  optionalQuestion3Segments: TextSegment[] = [];
  standardDeclarationSegments: TextSegment[] = [];
  dataProcessorNoticeSegments: TextSegment[] = [];
  legalTextSegments: TextSegment[] = [];

  formBuilder = inject(NonNullableFormBuilder);
  
    dataProtectionForm = this.formBuilder.group({
      mandatoryQuestion:[''],
      optionalQuestion1:[''],
      optionalQuestion2:[''],
      optionalQuestion3:[''],
      standardDeclaration: ['']
    })
  
    loading = false;


  constructor(private businessService: BusinessService, private matDialog: MatDialog, private assessmentService: AssessmentService) { }



  ngOnInit(): void {

    this.model = this.model || new InitialAssessmentForm();
    this.model.dataProtection = this.model.dataProtection;

    this.loading = true;
    if(this.model.dataProtection == null || this.model.dataProtection == undefined){

    this.businessService.getDeclarations().subscribe(declarations => {
      this.model.dataProtection = declarations;
      this.updateModel();
      this.initializeForm();
      this.loading = false;
      this.formReady.emit(this.dataProtectionForm);
    });
  
    } else {
      this.updateModel();
      this.initializeForm();
      this.loading = false;
      this.formReady.emit(this.dataProtectionForm);
    }

    

  }


    initializeForm(){
          
    this.patchFormWithAnswers();

    this.dataProtectionForm?.valueChanges.subscribe(value => {
    this.model.dataProtection = {
      legalText: this.model.dataProtection?.legalText || '',
      mandatoryQuestion: {
        question: this.model.dataProtection?.mandatoryQuestion?.question || '',
        answer: this.convertToBooleanAnswer(value.mandatoryQuestion),
        checkboxClassId: this.model.dataProtection?.mandatoryQuestion?.checkboxClassId ?? null
      } as DataProtectionQuestion,
      optionalQuestion1: {
        question: this.model.dataProtection?.optionalQuestion1?.question || '', 
        answer: this.convertToBooleanAnswer(value.optionalQuestion1)
      } as DataProtectionQuestion,
      optionalQuestion2: {
        question: this.model.dataProtection?.optionalQuestion2?.question || '', 
        answer: this.convertToBooleanAnswer(value.optionalQuestion2)
      } as DataProtectionQuestion,  
      optionalQuestion3: {    
        question: this.model.dataProtection?.optionalQuestion3?.question || '', 
        answer: this.convertToBooleanAnswer(value.optionalQuestion3)
      } as DataProtectionQuestion,
      standardDeclaration: {  
        question: this.model.dataProtection?.standardDeclaration?.question || '', 
        answer: this.convertToBooleanAnswer(value.standardDeclaration)
      } as DataProtectionQuestion,
      dataProcessorNotice: this.model.dataProtection?.dataProcessorNotice || ''
    } as DataProtection;    
  });
 
    
  
  }


private patchFormWithAnswers(): void {
  const patchValues = {
    mandatoryQuestion: this.convertBooleanToFormValue(this.model.dataProtection?.mandatoryQuestion?.answer),
    optionalQuestion1: this.convertBooleanToFormValue(this.model.dataProtection?.optionalQuestion1?.answer),
    optionalQuestion2: this.convertBooleanToFormValue(this.model.dataProtection?.optionalQuestion2?.answer),
    optionalQuestion3: this.convertBooleanToFormValue(this.model.dataProtection?.optionalQuestion3?.answer),
    standardDeclaration: this.convertBooleanToFormValue(this.model.dataProtection?.standardDeclaration?.answer)
  };

  this.dataProtectionForm.patchValue(patchValues);
}

private convertBooleanToFormValue(booleanValue: boolean | null | undefined): string {
  if (booleanValue === true) {
    return 'true';
  }
  if (booleanValue === false) {
    return 'false';
  }
  return '';
}

private convertToBooleanAnswer(formValue: string | undefined): boolean | null {
  if (formValue === undefined || formValue === '') {
    return null;
  }
  
  const lowerValue = formValue.toLowerCase();
  if (lowerValue === 'true' || lowerValue === 'yes' || lowerValue === '1') {
    return true;
  }
  if (lowerValue === 'false' || lowerValue === 'no' || lowerValue === '0') {
    return false;
  }
  
  return null;
}


   private updateModel(): void {

    if (this.model && this.model.dataProtection) {

      if(this.model.dataProtection.legalText !== null && this.model.dataProtection.legalText != ''){
        this.legalTextSegments = this.parseTextWithLinks(this.model.dataProtection.legalText!);
        this.showLegalText = true;
      }

      if(this.model.dataProtection.mandatoryQuestion !== null && this.model.dataProtection.mandatoryQuestion.question != ''){
        this.mandatoryQuestionSegments = this.parseTextWithLinks(this.model.dataProtection.mandatoryQuestion.question!);
        this.showMandatoryQuestion = true;
      }
      if(this.model.dataProtection.optionalQuestion1 !== null && this.model.dataProtection.optionalQuestion1.question != ''){
        this.optionalQuestion1Segments = this.parseTextWithLinks(this.model.dataProtection.optionalQuestion1.question!);
        this.showOptionalQuestion1 = true;
      }
      if(this.model.dataProtection.optionalQuestion2 !== null && this.model.dataProtection.optionalQuestion2.question != ''){
        this.optionalQuestion2Segments = this.parseTextWithLinks(this.model.dataProtection.optionalQuestion2.question!);
        this.showOptionalQuestion2 = true;
      }
      if(this.model.dataProtection.optionalQuestion3 !== null && this.model.dataProtection.optionalQuestion3.question != ''){
        this.optionalQuestion3Segments = this.parseTextWithLinks(this.model.dataProtection.optionalQuestion3.question!);
        this.showOptionalQuestion3 = true;
      }
      if(this.model.dataProtection.standardDeclaration !== null && this.model.dataProtection.standardDeclaration.question != ''){
        this.standardDeclarationSegments = this.parseTextWithLinks(this.model.dataProtection.standardDeclaration.question!);
        this.showStandardDeclaration = true;
      }
      if(this.model.dataProtection.dataProcessorNotice !== null && this.model.dataProtection.dataProcessorNotice != ''){
        this.dataProcessorNoticeSegments = this.parseTextWithLinks(this.model.dataProtection.dataProcessorNotice!);
        this.showDataProcessorNotice = true;
      }

      this.applyValidators();
    }
  }


  private applyValidators(): void {
  // Clear all validators first
  this.dataProtectionForm.controls.mandatoryQuestion.setValidators([]);
  this.dataProtectionForm.controls.optionalQuestion1.setValidators([]);
  this.dataProtectionForm.controls.optionalQuestion2.setValidators([]);
  this.dataProtectionForm.controls.optionalQuestion3.setValidators([]);
  this.dataProtectionForm.controls.standardDeclaration.setValidators([]);

  if (this.showMandatoryQuestion) {
    this.dataProtectionForm.controls.mandatoryQuestion.setValidators([
      this.mustBeYesValidator()
    ]);
  }

  if (this.showOptionalQuestion1) {
    this.dataProtectionForm.controls.optionalQuestion1.setValidators([Validators.required]);
  }

  if (this.showOptionalQuestion2) {
    this.dataProtectionForm.controls.optionalQuestion2.setValidators([Validators.required]);
  }

  if (this.showOptionalQuestion3) {
    this.dataProtectionForm.controls.optionalQuestion3.setValidators([Validators.required]);
  }

  if (this.showStandardDeclaration) {
    this.dataProtectionForm.controls.standardDeclaration.setValidators([
      Validators.requiredTrue
    ]);
  }

  this.dataProtectionForm.updateValueAndValidity();
}

private mustBeYesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === 'true') {
      return null;
    }
    return { mustBeYes: true };
  };
}
 
private parseTextWithLinks(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  const linkRegex = /<a[^>]*href=["']([^"']*)["'][^>]*>(.*?)<\/a>/gi;
  
  let lastIndex = 0;
  let match;

  // Search through the text looking for links and slit the text into segments
  // for links get the href and text and for non-links just get the text. 
  while ((match = linkRegex.exec(text)) !== null) {
   
    if (match.index > lastIndex) {
      const beforeText = text.substring(lastIndex, match.index);
      if (beforeText.trim()) {
        segments.push({ text: beforeText });
      }
    }

    segments.push({
      text: match[2],
      link: match[1] 
    });

    lastIndex = match.index + match[0].length;
  }


  if (lastIndex < text.length) {
    const remainingText = text.substring(lastIndex);
    if (remainingText.trim()) {
      segments.push({ text: remainingText });
    }
  }


  if (segments.length === 0 && text.trim()) {
    segments.push({ text: text });
  }

  return segments;
}

handleLinkClick(link: TextSegment): void {
  if (link.text.includes('Terms and Conditions')) {
    this.openTermsAndConditionsDialog();
  } else if (link.text.includes('Privacy Policy')) {
    this.showSecurityPrivacyCookiePolicyModal();
  } else if (link.link) {
    window.open(link.link, '_blank', 'noopener,noreferrer');
  }

}


    showSecurityPrivacyCookiePolicyModal() {
        var privacyDialog = this.matDialog.open(SecurityPrivacyCookiePolicyComponent, { panelClass: 'dialog-panel-large',  data: { appName: 'AssessmentApp' } });
    }
    
    openTermsAndConditionsDialog(){
        var termsDialog = this.matDialog.open(TermsAndConditionsComponent, { panelClass: 'dialog-panel-large', data: { appName: 'AssessmentApp' }});
    }

}
